import React, {Component} from 'react';
import {Table, Button} from 'react-bootstrap';
import swal from 'sweetalert';
import {translate}	from 'react-i18next';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import {bin} from 'react-icons-kit/icomoon/bin';
import ModalDetails from './modalDetails';
import Help from '../../generics/help';

const Config = require('../../../config');

class EntriesPlasmatic extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.handleChange = this.handleChange.bind(this);

		var aux_date = new Date();

		this.state = {
			list:[],
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			
		}
	}

	componentDidMount(){
		this.getList('inicial');
	}

	getList(inicial){
		this.props.waiting.handleShow('Cargando...');

		var apiUrl = 'plasmatic_product_purschase?start_date=&end_date=&hf_id='+sessionStorage.getItem('health_facilities_id');

		if(inicial === undefined){
			apiUrl = 'plasmatic_product_purschase?start_date='+this.state.start_date+'&end_date='+this.state.end_date+
						'&hf_id='+sessionStorage.getItem('health_facilities_id');
		}

		fetch(Config.default.apiGateway.URL+apiUrl, {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					list: response
				});
			}
		});
	}

	newEntry(){
		this.props.history.push('/entries_plasmatic_products/new');
	}

	viewInformation(item){
		this.modal_details.handleShow(item);
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm) => {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'plasmatic_product_purschase/'+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    });
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Servicios Entrada  
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_plasmatic_prod"} 
	                submenu={"help_plasmatic_entries"}  />

	            <div className="col-xs-12 form-group">
	             	<div className="col-xs-12 col-sm-2">
						<span className="span-min">Fecha Desde</span>
						<input className="form-control" type="date" name="start_date" id="start_date" 
							onChange={this.handleChange} 
							value={this.state.start_date} autoFocus={true} />
					</div>
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Fecha Hasta</span>
						<input className="form-control" type="date" name="end_date" id="end_date" 
							onChange={this.handleChange} 
							value={this.state.end_date}  />
					</div>

					<div className="col-xs-12 col-sm-4" style={{marginTop:'10px'}}>
						<button type="button" className="btn btn-info" onClick={()=>this.getList()} 
							style={{fontSize:"14px", marginRight:"5px"}}
							>
							Buscar
						</button>
						<button type="button" className="btn btn-info" style={{fontSize:"14px"}}
							disabled={!this.props.task_plasmatic_entries.create}
							onClick={this.newEntry}>Nuevo</button>
					</div>
				</div>

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Fecha Entrada</th>
								<th>Proveedor</th>
								<th>Folio Factura</th>
								<th>Fecha Factura</th>
								
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((l, i)=>(
								<tr key={i}>
									<td>{moment(l.purschase.entry_date).format('DD/MM/YYYY')}</td>
									<td>{l.provider}</td>
									<td>{l.purschase.purchase_folio}</td>
									<td>{l.purschase.purchase_date !== null ?  moment(l.purschase.purchase_date).format('DD/MM/YYYY') : ''}</td>
									<td>
										<Button className="btn btn-info btn-xs" title="Detalles" style={{marginRight:"5px"}} 
											onClick={this.viewInformation.bind(this, l)} >
											<SvgIcon icon={search}/>
										</Button>
										<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
											onClick={(e)=>this.onDelete(l.purschase.id)}
											disabled={!this.props.task_plasmatic_entries.delete} >
											<SvgIcon icon={bin} />
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>

				<ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(EntriesPlasmatic);